export default __webpack_public_path__ + "static/media/polad.bf9234e4.jpg";